var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"device",staticClass:"device-container",style:({height: _vm.container_height, maxWidth: _vm.container_width})}),_c('div',{ref:"controls",staticClass:"video-controls"})])
}
var staticRenderFns = []

export { render, staticRenderFns }